export default {
	tabs: {
		user: "Paramètres utilisateur",
		customer: "Compte client",
		delivery: "Adresses de livraison",
		invoice: "Adresses de facturation",
	},
};
